// ── AR Flow — NOVA INTERFACE, Etapa 9: menu de baixo no celular ───────────────
// A lista de abas vem do perfil ativo e a navegação passa pela mesma função
// setTab do menu lateral, mantendo as travas de saída das conversas.

import { useState } from "react";

const PRIORIDADE = ["central", "leads", "kanban", "prospeccao", "dashboard", "indicacoes", "lembretes"];
const NOMES = {
  central: "Meu Dia", leads: "Leads", kanban: "Presencial", prospeccao: "Prospecção", dashboard: "Dashboard",
  indicacoes: "Indicação", lembretes: "Lembretes", entregas: "Entregas", recebimentos: "Recebimentos", ia: "IA",
  historico: "Histórico", followup: "Follow-up", reports: "Relatórios", admin: "Lojas", inbox: "Conversas", vendas: "Vendas",
  produtos: "Produtos", biblioteca: "Biblioteca", marketing: "Marketing", catalogo: "Catálogo",
};
const ICONES = {
  central: "☀️", leads: "📋", kanban: "🗂", prospeccao: "📱", dashboard: "📊", indicacoes: "🤝", lembretes: "📌",
  entregas: "📦", recebimentos: "💵", ia: "💡", historico: "📅", followup: "🔁", reports: "📈", admin: "🏢", inbox: "💬", vendas: "💰",
  produtos: "🔎", biblioteca: "📷", marketing: "📊", catalogo: "📚",
};

export function mobileNavCount(label, tabId = "") {
  const text = String(label || "");
  const match = tabId === "lembretes"
    ? /\bLembretes\s*\((\d+)\)/i.exec(text)
    : /\((\d+)\)/.exec(text);
  return match ? Number(match[1]) : 0;
}

export function mobileNavGroups(tabs) {
  const available = Array.isArray(tabs) ? tabs : [];
  const availableIds = new Set(available.map(tab => tab.id));
  const primaryIds = PRIORIDADE.filter(id => availableIds.has(id)).slice(0, 4);
  return {
    primary:primaryIds.map(id => available.find(tab => tab.id === id)),
    more:available.filter(tab => !primaryIds.includes(tab.id)),
  };
}

export default function MobileNav({ theme, tabs, activeTab, onSelect }) {
  const th = theme;
  const [maisAberto, setMaisAberto] = useState(false);
  const { primary, more } = mobileNavGroups(tabs);
  const maisAtivo = more.some(tab => tab.id === activeTab);
  const escolher = id => { setMaisAberto(false); onSelect(id); };
  const item = ativo => ({
    flex: 1, minWidth: 0, background: "none", border: "none", padding: "6px 2px 4px", cursor: "pointer",
    display: "flex", flexDirection: "column", alignItems: "center", gap: 2, fontFamily: "inherit",
    color: ativo ? th.accent : th.muted, fontWeight: ativo ? 700 : 500, fontSize: 11, position: "relative",
  });

  return (
    <>
      <style>{`
.nu-mnav { display: none; }
@media (max-width: 899px) {
  .nu-mnav { display: flex; }
  body .nu-root .nu-tabs-row { display: none !important; }
  .nu-root { padding-bottom: calc(64px + env(safe-area-inset-bottom, 0px)); }
}`}</style>
      <nav className="nu-mnav" aria-label="Menu principal" style={{
        position: "fixed", left: 0, right: 0, bottom: 0, zIndex: 40, background: "#fff",
        borderTop: `1px solid ${th.nuLine || th.sandDark}`, paddingBottom: "env(safe-area-inset-bottom, 0px)",
      }}>
        {primary.map(tab => {
          const count = mobileNavCount(tab.label, tab.id);
          const active = activeTab === tab.id;
          return (
            <button key={tab.id} type="button" onClick={() => escolher(tab.id)} aria-current={active ? "page" : undefined} style={item(active)}>
              <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>{ICONES[tab.id] || "•"}</span>
              <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "100%" }}>
                {NOMES[tab.id] || tab.label}
              </span>
              {count > 0 && <span aria-label={`${count} pendentes`} style={{
                position: "absolute", top: 2, right: "22%", background: "#B42318", color: "#fff", borderRadius: 99,
                fontSize: 10, fontWeight: 700, padding: "0 5px", lineHeight: "16px",
              }}>{count}</span>}
            </button>
          );
        })}
        {more.length > 0 && (
          <button type="button" onClick={() => setMaisAberto(true)} aria-haspopup="dialog" aria-expanded={maisAberto} style={item(maisAtivo)}>
            <span aria-hidden="true" style={{ fontSize: 20, lineHeight: 1 }}>☰</span>
            <span>Mais</span>
          </button>
        )}
      </nav>

      {maisAberto && (
        <div role="dialog" aria-modal="true" aria-label="Mais opções" onClick={() => setMaisAberto(false)} style={{
          position: "fixed", inset: 0, zIndex: 45, background: "rgba(15,31,61,0.45)", display: "flex", alignItems: "flex-end",
        }}>
          <div onClick={event => event.stopPropagation()} style={{
            background: "#fff", width: "100%", borderRadius: "12px 12px 0 0",
            padding: "10px 8px calc(16px + env(safe-area-inset-bottom, 0px))", maxHeight: "70vh", overflowY: "auto",
          }}>
            <div style={{ width: 40, height: 4, background: th.sandDark || "#E6DCCB", borderRadius: 2, margin: "0 auto 10px" }} />
            {more.map(tab => {
              const count = mobileNavCount(tab.label, tab.id);
              return (
                <button key={tab.id} type="button" onClick={() => escolher(tab.id)} aria-current={activeTab === tab.id ? "page" : undefined} style={{
                  width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "13px 12px", border: "none",
                  background: activeTab === tab.id ? (th.sandDark || "#F4EBDD") : "none", borderRadius: 6, cursor: "pointer",
                  fontFamily: "inherit", fontSize: 16, color: th.text, textAlign: "left",
                }}>
                  <span aria-hidden="true" style={{ fontSize: 20 }}>{ICONES[tab.id] || "•"}</span>
                  <span style={{ flex: 1 }}>{NOMES[tab.id] || tab.label}</span>
                  {count > 0 && <span aria-label={`${count} pendentes`} style={{
                    background: "#B42318", color: "#fff", borderRadius: 99, fontSize: 12, fontWeight: 700, padding: "1px 8px",
                  }}>{count}</span>}
                </button>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}